import React, { useEffect } from 'react';
import { UserCog } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { isImpersonating, getImpersonationMeta, exitImpersonation } from '../utils/impersonation';

const IS_UAT = process.env.REACT_APP_ENV === 'uat';

/** Fixed top strip shown while an admin is viewing/acting as another user.
 *  Sits below the sandbox banner (Wave 42.378) when both are active. */
const ImpersonationBanner = () => {
  const { user } = useAuth();
  const active = isImpersonating();

  useEffect(() => {
    document.body.style.paddingTop = active ? (IS_UAT ? '72px' : '40px') : (IS_UAT ? '32px' : '');
    return () => { document.body.style.paddingTop = IS_UAT ? '32px' : ''; };
  }, [active]);

  if (!active) return null;
  const meta = getImpersonationMeta();

  return (
    <div
      role="status"
      data-testid="impersonation-banner"
      style={IS_UAT ? { top: '32px' } : undefined}
      className="fixed top-0 left-0 right-0 z-[9999] h-10 bg-amber-900 text-amber-50 px-4 flex items-center justify-center gap-3 text-sm font-medium shadow-lg"
    >
      <UserCog className="h-4 w-4 shrink-0" />
      <span className="truncate">
        Viewing as <strong>{user?.name || user?.email}</strong> ({user?.role})
        {meta?.adminName ? ` — impersonated by ${meta.adminName}` : ''}
      </span>
      <button
        type="button"
        onClick={exitImpersonation}
        data-testid="exit-impersonation-btn"
        className="ml-2 px-3 py-1 rounded-full bg-amber-50 text-amber-900 font-semibold text-xs hover:bg-white transition-colors shrink-0"
      >
        Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
